import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import route from '../../utils/Routes';
import { useAuthContext } from '../../context/AuthContext';

function PrLinkPage() {
    const { ctxtUser, setLoadingScreen } = useAuthContext();
    const navigate = useNavigate();
    const { prodReqIdStrg } = useParams();

    useEffect(() => {
        setLoadingScreen(true);
        if (prodReqIdStrg) {
            if (ctxtUser?.isComUser) {
                navigate(`${route.cProdreqinfo}/?prodReqId=${prodReqIdStrg}`)
            }
            else {
                navigate(`${route.aProdreqinfo}/?prodReqId=${prodReqIdStrg}`)
            }
        } else {
            navigate(route.login, { replace: true });
        }
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<div>PoLinkPage</div>)
}

export default PrLinkPage